import React, { useState, useEffect } from 'react';
import { cloudAPI } from '../../utils/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function FeatureAdoptionPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cloudAPI.getFeatures()
            .then(res => setData(res.data))
            .catch(err => console.error('Features error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;
    if (!data) return <div className="text-red-500">Failed to load</div>;

    const rawProtocols = Array.isArray(data?.protocols) ? data.protocols
                        : Array.isArray(data?.rows) ? data.rows
                        : Array.isArray(data?.data) ? data.data
                        : [];
    const rawSources = Array.isArray(data?.content_sources) ? data.content_sources
                      : Array.isArray(data?.sources) ? data.sources
                      : [];
    // Backend returns {protocol, count} and {content_origin, count}; the BarChart
    // uses dataKey="sessions" / "source", so normalise here.
    const protocols = rawProtocols.map(r => ({
        protocol: r.protocol || r.name || 'unknown',
        sessions: Number(r.sessions ?? r.count ?? 0),
    }));
    const sources = rawSources.map(r => ({
        source: r.source || r.content_origin || r.name || 'unknown',
        count: Number(r.count ?? r.sessions ?? 0),
    }));

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Feature Adoption</h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                <div className="bg-white rounded-lg shadow-md p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4">Protocol Usage</h3>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={protocols}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="protocol" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="sessions" name="Sessions" fill="#667eea" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                <div className="bg-white rounded-lg shadow-md p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-4">Content Sources</h3>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={sources}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="source" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="count" name="Usage" fill="#f093fb" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}
